var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03594 3 3 7.03594 3 12C3 16.9641 7.03594 21 12 21C16.9641 21 21 16.9641 21 12C21 7.03594 16.9641 3 12 3ZM12 19.5C7.86563 19.5 4.5 16.1344 4.5 12C4.5 7.86563 7.86563 4.5 12 4.5C16.1344 4.5 19.5 7.86563 19.5 12C19.5 16.1344 16.1344 19.5 12 19.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5235 7.02189C13.1485 6.84376 12.5907 6.74533 12.0001 6.75001C11.1517 6.73595 10.336 7.03126 9.71259 7.58908C9.1454 8.09532 8.78446 8.76095 8.71884 9.4172C8.68134 9.77813 8.94384 10.1016 9.30477 10.1344C9.66571 10.1719 9.98915 9.90938 10.022 9.54845C10.0829 8.92501 10.8188 8.03907 11.9813 8.06251H12.0001C12.436 8.05782 12.7923 8.13282 12.9516 8.20782C13.9688 8.68595 13.9688 9.32813 13.9688 9.53907C13.9688 10.3875 13.4579 10.7719 12.5532 11.3766C11.5829 12.0281 11.1095 12.8484 11.1095 13.875C11.1095 14.2359 11.4048 14.5312 11.7657 14.5312C12.1266 14.5312 12.422 14.2359 12.422 13.875C12.422 13.4438 12.5251 12.975 13.2845 12.4688C14.1751 11.8734 15.2813 11.1328 15.2813 9.54376C15.2813 8.45626 14.6579 7.56095 13.5235 7.02189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 17.25C12.2365 17.25 12.6562 16.8303 12.6562 16.3125C12.6562 15.7947 12.2365 15.375 11.7188 15.375C11.201 15.375 10.7812 15.7947 10.7812 16.3125C10.7812 16.8303 11.201 17.25 11.7188 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.651b700fa262b641158c5f723b60927c.svg";
export { ForwardRef as ReactComponent };